import { Spin } from "@/components";
import * as GlobalS from "@/components/styled";
import * as S from "@/containers/Project/components/styled";
import {
  flattenMilestoneSchedulesForTableData,
  generateTableFromFlattenedMilestones,
} from "@/containers/Project/helper";
import { GUTTER_SIZE, ProjectUserPermissions } from "@/enums";
import { useProjectContext } from "@/providers";
import { useConfigurationQuery } from "@/services/appConfig";
import { Button, Col, Row, Space, Switch, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

export const SchedulesCard = () => {
  const intl = useIntl();
  const { canUser, setManageSchedulesModalOpen, project } = useProjectContext();
  const { data: configuration, isError: isConfigurationError } =
    useConfigurationQuery({});
  const keyMilestoneDashboardEnabled =
    !isConfigurationError && configuration?.keyMilestoneDashboardEnabled === true;

  const [expandedSchedules, setExpandedSchedules] = useState([0]);
  const [
    flattenedMilestonesDataBySchedule,
    setFlattenedMilestonesDataBySchedule,
  ] = useState();
  const [showChildren, setShowChildren] = useState(true);

  useEffect(() => {
    if (project?.schedules?.length) {
      const activeSchedules = project.schedules.filter(
        (schedule) => !schedule.isDeleted
      );
      const schedules = activeSchedules.map((schedule, index) => {
        const scheduleMilestones = flattenMilestoneSchedulesForTableData(
          schedule.milestones,
          schedule.id,
          showChildren
        );
        return {
          id: schedule.id,
          name: schedule.name,
          order: index,
          milestones: scheduleMilestones,
          sourceStart:
            index === 0 ? null : schedule.milestones?.[0]?.milestoneTemplateId,
        };
      });
      setFlattenedMilestonesDataBySchedule(schedules);
    }
  }, [project, showChildren]);

  const toggleSchedule = (schedule) => {
    if (expandedSchedules.includes(schedule)) {
      setExpandedSchedules(
        expandedSchedules.filter((expanded) => expanded !== schedule)
      );
    } else {
      setExpandedSchedules([...expandedSchedules, schedule]);
    }
  };

  if (!project) return <Spin />;

  return (
    <GlobalS.GrayCard
      size="small"
      title={intl.formatMessage({ id: "project.schedulesTitle" })}
      extra={
        <Row gutter={GUTTER_SIZE.small}>
          <Col className="m-auto" flex={1}>
            <Space>
              <Tooltip
                title={intl.formatMessage({
                  id: "milestonesList.topTooltip",
                })}
              >
                <Switch
                  checked={showChildren}
                  onChange={() => setShowChildren(!showChildren)}
                  data-test-id={"toggle-milestones-schedule-all"}
                  checkedChildren={intl.formatMessage({
                    id: "milestonesList.all",
                  })}
                  unCheckedChildren={intl.formatMessage({
                    id: "milestonesList.top",
                  })}
                />
              </Tooltip>
            </Space>
          </Col>
          {canUser(ProjectUserPermissions.EditSchedules) && (
            <Col flex={1}>
              <Button
                data-test-id={`add-edit-schedules-${project.id}`}
                key={`add-edit-schedules-${project.id}`}
                onClick={() => setManageSchedulesModalOpen(true)}
              >
                {intl.formatMessage({
                  id: "addScheduleModal.title",
                })}
              </Button>
            </Col>
          )}
        </Row>
      }
    >
      {flattenedMilestonesDataBySchedule ? (
        <>
          {generateTableFromFlattenedMilestones(
            flattenedMilestonesDataBySchedule,
            expandedSchedules,
            toggleSchedule,
            intl,
            project.id,
            keyMilestoneDashboardEnabled
          )}
          <S.StyledAlert
            type="warning"
            message={intl.formatMessage({
              id: keyMilestoneDashboardEnabled
                ? "projectMilestoneTable.datesDisclaimerActualCurrent"
                : "projectMilestoneTable.datesDisclaimer",
            })}
          />
        </>
      ) : (
        intl.formatMessage({ id: "project.missingMilestonesMessage" })
      )}
    </GlobalS.GrayCard>
  );
};
